export default __webpack_public_path__ + "static/media/logo13.0040a1eb.svg";